import { IPatternSegment } from "./IPatternSegment";

export class SimplePatternSegment implements IPatternSegment {
    constructor(private readonly patternPart: string) {}

    get name() {
        return this.isVariable
            ? this.patternPart.substring(1)
            : this.patternPart;
    }

    get isVariable() {
        return this.patternPart.startsWith(":");
    }

    match(pathPart: string): boolean {
        return this.isVariable ? true : this.patternPart === pathPart;
    }
}
